// src/pages/Contact.jsx - Alternative simpler version
import React from 'react';
import { Mail, Linkedin, Calendar } from 'lucide-react';

const Contact = () => {
  const actions = {
    email: () => {
      window.location.href = 'mailto:contact@a-ayoub.com?subject=Consultation Inquiry';
    },
    linkedin: () => {
      window.open('https://linkedin.com/in/ayoubabdel', '_blank');
    },
    calendly: () => {
      window.open('https://calendly.com/ayoub-abdelouahabi/meeting', '_blank');
    }
  };

  return (
    <section className="full-section">
      <div className="contact-container">
        {/* Header */}
        <div className="contact-header">
          <h1>Get in Touch</h1>
          <p className="contact-subtitle">
            Let's discuss how I can help with your technical challenges
          </p>
        </div>

        {/* Main Content */}
        <div className="contact-content">
          {/* Contact Cards */}
          <div className="contact-cards">
            <div className="contact-card">
              <div className="card-icon">
                <Calendar size={28} />
              </div>
              <h3>Schedule a Call</h3>
              <p>30-minute discovery session</p>
              <button 
                className="card-button" 
                onClick={actions.calendly}
                onMouseDown={(e) => e.stopPropagation()}
              >
                Book Now
              </button>
            </div>

            <div className="contact-card">
              <div className="card-icon">
                <Mail size={28} />
              </div>
              <h3>contact@a-ayoub.com</h3>
              <p>For detailed inquiries</p>
            </div>

            <div className="contact-card">
              <div className="card-icon">
                <Linkedin size={28} />
              </div>
              <h3>LinkedIn</h3>
              <p>Connect professionally</p>
              <button 
                className="card-button" 
                onClick={actions.linkedin}
                onMouseDown={(e) => e.stopPropagation()}
              >
                Connect
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;